import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/register",
    class: "btn btn-primary"
  }, "Join Now")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/login",
    class: "btn btn-secondary"
  }, "Sign In ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "View My HANDLE", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("List Item")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" View My Cart (")
const _hoisted_6 = { class: "cart-items-quantity" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Auctions ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Inventory ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Contact Us ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Sign Out ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!

  return (_openBlock(), _createBlock(_component_b_dropdown, {
    class: "main-menu",
    ref: "mainMenu"
  }, {
    "button-content": _withCtx(() => [
      _createVNode(_component_fa, {
        icon: "bars",
        style: {"width":"20px","height":"20px"}
      })
    ]),
    default: _withCtx(() => [
      (!_ctx.isUserLoggedIn)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_b_dropdown_item, null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_b_dropdown_item, null, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_b_dropdown_item, { disabled: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_fa, { icon: "user-circle" }),
                _createTextVNode(" Hello, " + _toDisplayString(_ctx.userFirstName()), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_b_dropdown_item, {
              class: "small",
              href: "/profile"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            (_ctx.accessSellTile)
              ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                  key: 0,
                  href: "/profile/items-create"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_fa, { icon: "tag" }),
                      _hoisted_4
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_b_dropdown_item, { href: "/cart" }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_fa, { icon: "shopping-cart" }),
                  _hoisted_5,
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.totalCount || '0'), 1),
                  _hoisted_7
                ])
              ]),
              _: 1
            })
          ], 64)),
      _createVNode(_component_b_dropdown_divider),
      (_ctx.accessAuctionTile)
        ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
            key: 2,
            href: "/auctions/active"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_b_dropdown_item, { href: "/shop" }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }),
      _createVNode(_component_b_dropdown_item, { href: "/contact-us" }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }),
      (_ctx.isUserLoggedIn)
        ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
            key: 3,
            onClick: _ctx.signOut
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}